<script setup lang="ts">
import CanvasButton from "@/components/canvas/CanvasButton.vue";
import DraggerMenuState from "@/stores/DraggerMenuState";
import { DraggerType } from "@/drawing";

withDefaults(defineProps<{ size?: "sm" | "md" }>(), { size: "md" });

function disable() {
  DraggerMenuState.setActiveDragger({ name: DraggerType.None });
}
</script>
<template>
  <CanvasButton
    :size="size"
    @click.prevent.stop="disable"
    :tooltipTitle="$t('canvas:tools.options.disableTool.tooltip.title')"
    :tooltipText="$t('canvas:tools.options.disableTool.tooltip.text')"
    phosphor-icon="x"
  />
</template>
